"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var color_1 = __importDefault(require("color"));
var colors_1 = __importDefault(require("../../assets/jss/colors"));
var material_kit_pro_react_1 = require("../../assets/jss/material-kit-pro-react");
exports.default = (function (theme) {
    var _a;
    return (0, core_1.makeStyles)({
        container: __assign(__assign({}, material_kit_pro_react_1.container), (_a = { display: 'flex', flexGrow: 1, alignItems: 'center', justifyContent: 'center' }, _a[theme.breakpoints.down('xs')] = {
            paddingLeft: 0,
            paddingRight: 0
        }, _a)),
        screen: {
            backgroundColor: (0, color_1.default)(theme.palette.background.default)
                .alpha(0.37)
                .rgb()
                .string(),
            minHeight: '100%',
            paddingBottom: theme.spacing(4)
        },
        box: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: theme.spacing(3),
            borderRadius: 5,
            backgroundColor: (0, color_1.default)(theme.palette.common.black)
                .alpha(0.04)
                .rgb()
                .string()
        },
        loadingBox: {
            display: 'flex',
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            height: 250
        },
        icon: {
            fontSize: 70,
            alignSelf: 'center'
        },
        iconSuccess: {
            color: colors_1.default.successColor.hex()
        },
        iconError: {
            color: colors_1.default.dangerColor.hex()
        },
        gotoText: {
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(3),
            textAlign: 'center'
        }
    });
});
//# sourceMappingURL=styles.js.map